import { jsx as i } from "react/jsx-runtime";
import { c as n } from "../../../../clsx-OuTLNxxd.js";
import { forwardRef as a } from "react";
import { I as m } from "../../../../icon-B72I4fRl.js";
import "../../icon/iconsList.js";
const c = "_disabled_1rzsq_47", s = {
  "icon-button": "_icon-button_1rzsq_29",
  "size-small": "_size-small_1rzsq_38",
  "size-medium": "_size-medium_1rzsq_41",
  "size-large": "_size-large_1rzsq_44",
  disabled: c,
  "is-borderless": "_is-borderless_1rzsq_51",
  "dialog-overlay-show": "_dialog-overlay-show_1rzsq_1",
  "dialog-content-show": "_dialog-content-show_1rzsq_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1rzsq_1"
}, z = a(
  ({ icon: r, size: o, isBorderless: t, onClick: l, className: _, ...e }, d) => /* @__PURE__ */ i(
    "button",
    {
      ref: d,
      className: n(
        s["icon-button"],
        e.disabled && s.disabled,
        o && s[`size-${o}`],
        t && s["is-borderless"],
        _
      ),
      onClick: l,
      ...e,
      children: /* @__PURE__ */ i(m, { name: r, size: o })
    }
  )
);
z.displayName = "IconButton";
export {
  z as IconButton
};
